import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ExistingApplication from '@sunbit-dev/ui/src/components/card-apply/pages/existingApplication/ExistingApplication';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { existingApplicationThunk } from '../actions/identificationActions';
import { selectApplicationDetails, selectInitialDetails, selectIdentificationErrorCode } from '../selectors';
import ApplicationStatus from '@sunbit-dev/common/enums/cardApply/ApplicationStatus';
import { IdentificationErrors } from '@sunbit-dev/ui/src/components/card-apply/pages/identification/Identification';
import { ERROR_CODES } from '../errors/errors';
import { selectShowPlasticAddressModal } from '../selectors';
import { showPlasticAddressModal } from '../actions/plasticAddressActions';


const ExistingApplicationContainer: React.FC = () => {
  const dispatch = useDispatch();

  const plasticAddressModalVisible = useSelector(selectShowPlasticAddressModal);
  const initialDetails = useSelector(selectInitialDetails);
  const applicationDetails = useSelector(selectApplicationDetails);
  const errorCode = useSelector(selectIdentificationErrorCode);

  const submit = React.useCallback(
    (ssnLast4Digits: string) => {
      dispatch(existingApplicationThunk(ssnLast4Digits));
    },
    [dispatch]
  );

  const completeMyApplicationAction = React.useCallback(() => {
    dispatch(showPlasticAddressModal());
  }, [dispatch]);

  if (initialDetails.status === ActionStatus.Failure) {
    return <>error</>;
  }
  if (initialDetails.status !== ActionStatus.Success) {
    return null;
  }

  let error: IdentificationErrors | undefined;
  switch (errorCode) {
    case ERROR_CODES.loginFailed:
      error = IdentificationErrors.detailsDontMatch;
      break;
  }

  const props = {
    ssnLast4Digits: '',
    firstName: initialDetails.customerFirstName || '',
    applicationStatus: applicationDetails.applicationStatus || ApplicationStatus.INITIAL,
    accountCreationDate: applicationDetails.accountCreationDate || '',
    error,
    submit,
    completeMyApplicationAction,
    plasticAddressModalVisible
  };

  return <ExistingApplication {...props} />;
};

export default ExistingApplicationContainer;
